import {
  useGetAccountManagersQuery,
  useGetPodsV2Query,
} from '@components/Users/slice/usersSlice';
import { Campaign } from '@features/campaigns';
import { Box, Chip } from '@mui/material';
import { values } from './values';

export type AccountManagerProps = {
  campaign: Pick<Campaign, 'id' | 'accountManagerIds' | 'podIds'>;
};

export const AccountManager = (props: AccountManagerProps) => {
  const { data: managers } = useGetAccountManagersQuery();
  const { data: pods } = useGetPodsV2Query();

  if (!managers || !pods) return null;

  const currentValues = values({
    accountManagerIds: props.campaign.accountManagerIds,
    podIds: props.campaign.podIds,
    accountManagers: managers.accountManagers,
    pods,
  });

  return (
    <Box display="flex" flexWrap="wrap" gap={0.5} alignItems="center">
      {currentValues.map(manager => (
        <Chip
          key={manager.id}
          label={manager.label}
          size="small"
          variant="outlined"
          color="primary"
        />
      ))}
    </Box>
  );
};
